import type { Component } from 'solid-js'
import { Icon } from '@iconify-icon/solid'

interface DeleteEventDialogProps {
  readonly eventTitle: string
  readonly onCancel: () => void
  readonly onConfirm: () => void
}

const DeleteEventDialog: Component<DeleteEventDialogProps> = (props) => {
  return (
    <div
      class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/30 animate-[fade-in_150ms_ease-out]"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.onCancel()
      }}
    >
      <div class="w-96 p-4 bg-white rounded-lg border border-gray-200 shadow-xl flex flex-col gap-4 animate-menu-enter">
        {/* Header + description */}
        <div class="flex flex-col gap-1">
          <div class="flex items-center justify-between">
            <h3 class="text-base font-semibold text-gray-900">Delete an event</h3>
            <button
              type="button"
              class="w-8 h-8 rounded-md flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors duration-150"
              onClick={props.onCancel}
            >
              <Icon icon="heroicons:x-mark" class="text-[1rem]" />
            </button>
          </div>
          <p class="text-sm text-gray-400">
            You will permanently delete this event: <span class="text-gray-500">{props.eventTitle}</span>.
          </p>
        </div>

        {/* Actions */}
        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="min-w-20 px-3 py-2 bg-white rounded-md shadow-sm border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors duration-150"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            class="min-w-20 px-3 py-2 bg-red-600 rounded-md shadow-sm text-sm font-semibold text-white hover:bg-red-700 transition-colors duration-150"
            onClick={props.onConfirm}
          >
            Delete event
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteEventDialog
